import React from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import BottomBanner from "components/bottomBanner/bottomBanner";
import { ModalProvider } from "components/modal/provider";
import OnboardingDialog from "components/onboarding/onboarding";
import CompleteProfilePrompt from "components/zephr/CompleteProfilePrompt";
import LoginRegistrationModal from "components/zephr/LoginRegistrationModal";

const EmailVerificationBannerNoSSR = dynamic(
  () => import("content-ui/emailVerificationBanner/emailVerificationBanner"),
  { ssr: false }
);

const AUTH_FLOW_PATHS = [
  "/members/complete-profile",
  "/members/login",
  "/members/verification-failed",
  "/members/verification-result",
  "/verify-email",
];

const AppContent = ({ Component, pageProps }) => {
  const { pathname } = useRouter();
  const isAuthFlow = AUTH_FLOW_PATHS.some((path) => pathname.startsWith(path));

  return (
    <div className={`font-serif`}>
      <ModalProvider>
        <>
          <OnboardingDialog />
          <CompleteProfilePrompt />
        </>
      </ModalProvider>
      <Component {...pageProps} />
      {!isAuthFlow && <LoginRegistrationModal />}
      {!isAuthFlow && (
        <BottomBanner preview={pageProps.preview || pageProps.previewMode} />
      )}
      <EmailVerificationBannerNoSSR />
    </div>
  );
};

export default AppContent;
